// ============================================================
// BLACK OWL - Tab title flash
// ============================================================
// Alternates document.title with a short message while `message`
// is set, so a background tab says something needs attention.
// FB-22 uses it for "your pick"; FB-15 phase 1 reuses it for
// new arrows and penalties.
// ============================================================

import { useEffect } from "react";

export function useTitleFlash(message, intervalMs = 1000) {
  useEffect(() => {
    if (!message) return undefined;
    const original = document.title;
    let showMessage = true;
    document.title = message;
    const id = setInterval(() => {
      showMessage = !showMessage;
      document.title = showMessage ? message : original;
    }, intervalMs);
    return () => {
      clearInterval(id);
      document.title = original;
    };
  }, [message, intervalMs]);
}
